<template>
  <div class="management">
    <header class="management-header">
      <h1>后台管理</h1>
      <p class="description">选择要管理的内容模块</p>
    </header>

    <section class="module-grid" aria-label="管理模块">
      <button
        v-for="module in modules"
        :key="module.title"
        class="module-card"
        type="button"
        @click="module.open"
      >
        <span class="module-icon" aria-hidden="true">{{ module.icon }}</span>
        <span class="module-copy">
          <span class="module-title">{{ module.title }}</span>
          <span class="module-description">{{ module.description }}</span>
        </span>
        <span class="module-arrow" aria-hidden="true">›</span>
      </button>
    </section>

    <Doctor v-model:visible="doctorVisible" />
    <Department v-model:visible="departmentVisible" />
    <News v-model:visible="newsVisible" />
    <Team v-model:visible="teamVisible" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Doctor from "./components/doctor.vue";
import Department from "./components/department.vue";
import News from "./components/news.vue";
import Team from "./components/team.vue";

const doctorVisible = ref(false);
const departmentVisible = ref(false);
const newsVisible = ref(false);
const teamVisible = ref(false);

const modules = [
  {
    title: "专家管理",
    description: "维护专家资料与信息",
    icon: "专家",
    open: () => (doctorVisible.value = true),
  },
  {
    title: "科室管理",
    description: "维护科室部门信息",
    icon: "科室",
    open: () => (departmentVisible.value = true),
  },
  {
    title: "新闻管理",
    description: "发布与维护新闻动态",
    icon: "宣传",
    open: () => (newsVisible.value = true),
  },
  {
    title: "团队管理",
    description: "维护团队介绍与资料",
    icon: "团队",
    open: () => (teamVisible.value = true),
  },
];
</script>

<style scoped>
.management {
  width: 100%;
  max-width: 1200px;
  margin: 5rem auto 0;
  padding: 0 2rem 4rem;
}

.management-header {
  margin-bottom: 2rem;
}

.eyebrow {
  margin-bottom: 0.5rem;
  color: #398b78;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
}

h1 {
  color: #203b37;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
}

.description {
  margin-top: 0.5rem;
  color: #71817e;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.module-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-height: 112px;
  padding: 1.25rem;
  border: 1px solid #e4eeeb;
  border-radius: 12px;
  background: #fff;
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;
}

.module-card:hover {
  transform: translateY(-2px);
  border-color: #80b9aa;
  box-shadow: 0 8px 24px rgb(32 86 73 / 10%);
}

.module-card:focus-visible {
  outline: 3px solid rgb(57 139 120 / 35%);
  outline-offset: 3px;
}

.module-icon {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  place-items: center;
  border-radius: 12px;
  background: #eaf5f1;
  color: #32806e;
  font-size: 1.25rem;
  font-weight: 700;
}

.module-copy {
  display: grid;
  gap: 0.35rem;
  flex: 1;
}

.module-title {
  color: #263d39;
  font-size: 1.05rem;
  font-weight: 650;
}

.module-description {
  color: #7a8986;
  font-size: 0.875rem;
}

.module-arrow {
  color: #8b9a96;
  font-size: 1.75rem;
  line-height: 1;
}

@media (max-width: 640px) {
  .management {
    margin-top: 3rem;
    padding: 0 1rem 3rem;
  }

  .module-grid {
    grid-template-columns: 1fr;
  }
}
</style>
